module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_9016.24e12dc0.png";